/**
 * Identité légale de la société — source unique de vérité.
 *
 * Ces valeurs alimentent le pied de page, les mentions légales et la politique
 * de confidentialité. Si une information change (adresse e-mail, hébergeur,
 * siège social), elle ne doit être modifiée QU'ICI.
 */

export const company = {
  legalName: "ZARAFA CONSULTING",
  tradeName: "Zarafa Consulting",
  legalForm: "Société par actions simplifiée à associé unique (SASU)",
  capital: "1 000 €",
  address: {
    street: "39 boulevard Georges Clémenceau",
    zip: "83000",
    city: "Toulon",
    country: "France",
  },
  siren: "983 626 615",
  rcs: "983 626 615 R.C.S. Toulon",
  vat: "FR80 983 626 615",
  // ⚠️ Vérifier que cet alias existe bien dans Google Workspace avant de déployer.
  email: "contact@zarafa-consulting.com",
  phone: "+33 6 26 30 74 44",
  publicationDirector: "Oualid Jouhri",
  publicationDirectorRole: "Président",
  website: "https://www.zarafa-consulting.com",
};

/** Hébergeur du site — à mettre à jour en cas de migration. */
export const host = {
  name: "Cloudflare, Inc.",
  address: "101 Townsend Street, San Francisco, CA 94107, États-Unis",
  website: "https://www.cloudflare.com",
};

/** Sous-traitant qui achemine les messages du formulaire de contact. */
export const formProcessor = {
  name: "Formspree, Inc.",
  country: "États-Unis",
  website: "https://formspree.io",
  privacyUrl: "https://formspree.io/legal/privacy-policy/",
};

/** Durée de conservation des messages reçus via le formulaire. */
export const contactRetention = "3 ans à compter du dernier échange";

/** Date de dernière mise à jour des textes légaux (format AAAA-MM-JJ). */
export const legalUpdatedAt = "2026-08-29";

export const legalUpdatedAtLabel = new Date(legalUpdatedAt).toLocaleDateString(
  "fr-FR",
  { day: "numeric", month: "long", year: "numeric" }
);

export const fullAddress = `${company.address.street}, ${company.address.zip} ${company.address.city}, ${company.address.country}`;
